module.exports = __webpack_public_path__ + "img/journey1-D.b3ea55ff.png";